import React from "react";
import PeopleBackground from "./images/peopleBackground.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const ConnectMentor = () => {
  const items = [
    {
      label: "Expert Advice:",
      description:
        "Get personalised explanations and actionable insights based on your AI Job Assessment report.",
    },
    {
      label: "Tailored Career Pathways:",
      description:
        "Work with mentors to explore the career recommendations provided by assessment and develop a customised action plan.",
    },
    {
      label: "Skill Development Strategies:",
      description:
        "Identify key skills to develop or enhance, with mentors suggesting specific resources and training aligned with your assessment.",
    },
    {
      label: "Networking Opportunities:",
      description:
        "Expand your professional network within your desired industry, leveraging connections that align with your career transition goals.",
    },
    {
      label: "Accountability and Motivation:",
      description:
        "Stay motivated and on track with your career development plan through regular check-ins and support from your mentor.",
    },
  ];
  const navigate = useNavigate();
  return (
    <div className="relative w-full max-w-screen-xl mx-auto px-6 sm:px-8 py-10 flex flex-col md:flex-row items-center gap-8 lg:gap-16 bg-white shadow-lg rounded-lg">
      {/* Left Section: Image */}
      <div className="flex justify-center w-full md:w-1/2">
        <img
          src={PeopleBackground}
          alt="People Background"
          className="rounded-xl object-cover w-full max-w-md"
        />
      </div>

      {/* Right Section: Content */}
      <div className="flex flex-col w-full md:w-1/2 text-center md:text-left space-y-6">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-snug">
          Why Connect with a Mentor?
        </h1>

        {/* List of Benefits */}
        <div className="space-y-4">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center md:items-start"
            >
              <h2 className="text-lg font-semibold text-gray-800">
                {item.label}
              </h2>
              <p className="text-sm text-gray-600 mt-1">{item.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="mt-6">
          <button
            onClick={() => navigate("/auth/login")}
            className="flex items-center justify-center w-full md:w-auto bg-custom-gradient text-white px-6 py-3 rounded-full font-semibold hover:opacity-90 transition"
          >
            Find Your Mentor
            <FaArrowRightLong className="ml-2" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectMentor;
